import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import { adminCreatePaymentAdjustment, adminGetPermissions } from './adminApi';
import { RootState } from '../..';
import { IRolePermissions } from '../RolesSlice';
import { ITutorRolePermissions } from '../TutorRolesSlice';

// PERMISSIONS
export interface IPermissions {
  admin: IRolePermissions;
  user: IRolePermissions;
  tutor: ITutorRolePermissions;
}

// ADJUSTMENTS
export const PAYMENT_ADJUSTMENT_TYPES = {
  PAYMENT: 'PAYMENT',
  ADJUSTMENTS: 'ADJUSTMENTS',
  COURSE_TOPUP: 'COURSE_TOPUP',
  OTHERS: 'OTHERS',
} as const;

export type TPaymentAdjustmentTypes = typeof PAYMENT_ADJUSTMENT_TYPES[keyof typeof PAYMENT_ADJUSTMENT_TYPES];

export interface IInitialSettingsState {
  status: 'idle' | 'loading' | 'rejected';
  // PERMISSIONS
  adminPermissionsList?: IPermissions;
}

const initialState: IInitialSettingsState = {
  status: 'idle',
  // PERMISSIONS
  adminPermissionsList: undefined,
};

export const SettingsSlice = createSlice({
  initialState,
  name: 'settings',
  reducers: {
    // PERMISSIONS
    resetAdminPermissionsList: (state) => {
      state.adminPermissionsList = undefined;
    },
  },
  extraReducers(builder) {
    // PERMISSIONS
    builder.addCase(adminGetPermissions.fulfilled, (state, action) => {
      state.adminPermissionsList = action.payload;
    });

    // Common Matchers
    builder.addMatcher(
      isFulfilled(
        // ADJUSTMENTS
        adminCreatePaymentAdjustment
      ),
      (state) => {
        state.status = 'idle';
      }
    );

    builder.addMatcher(
      isPending(
        // ADJUSTMENTS
        adminCreatePaymentAdjustment
      ),
      (state) => {
        state.status = 'loading';
      }
    );

    builder.addMatcher(
      isRejected(
        // ADJUSTMENTS
        adminCreatePaymentAdjustment
      ),
      (state) => {
        state.status = 'rejected';
      }
    );
  },
});

export const getSettingsState = (state: RootState): RootState['settings'] =>
  state.settings;

export * from './adminApi';
export default SettingsSlice.reducer;
